import React from 'react';
import EditScheduledReportPage from './EditScheduledReportPage';
import { connect } from 'react-redux';
import { configureActions } from '../../../../../actions/configure.action';
import { isEqual } from 'lodash';
import helper from '../../../../../utils/helper';
import lookupActions from '../../../../../actions/lookup.actions';
import { bindActionCreators } from 'redux';

class EditScheduledReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      scheduledReport: {},
      getScheduledReportError: {},
      groups: [],
      sensorTypes: [],
      isFetching: false,
      isSubmitting: false,
      errors: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let state = {};
    // if (nextProps.configure.scheduledReport !== prevState.scheduledReport) {
    //   state.scheduledReport = nextProps.configure.scheduledReport;
    // }
    if (nextProps.configure.sensorTypes !== prevState.sensorTypes) {
      state.sensorTypes = nextProps.configure.sensorTypes;
    }
    if (nextProps.lookup.groups !== prevState.groups) {
      state.groups = nextProps.lookup.groups;
    }
    if (
      nextProps.configure.getScheduledReportError !==
      prevState.getScheduledReportError
    ) {
      state.getScheduledReportError =
        nextProps.configure.getScheduledReportError;
    }
    state.errors = helper.centralizeError([
      nextProps.configure.errors,
      nextProps.lookup.errors,
    ]);
    if (nextProps.configure.isFetching !== prevState.isFetching) {
      state.isFetching = nextProps.configure.isFetching;
    }
    if (nextProps.configure.isSubmitting !== prevState.isSubmitting) {
      state.isSubmitting = nextProps.configure.isSubmitting;
    }
    return Object.keys(state).length ? state : null;
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    await this.props.lookupActions.getGroupsForScheduledReports();
    await this.props.configureActions
      .getSpecificScheduledReport(id)
      .then((resp) => {
        this.setState(
          { scheduledReport: resp },
          async () =>
            await this.props.configureActions.getSensorTypesByReports(
              resp.groupId,
            ),
        );
      });
  }

  onChangeGroup = async (groupId) => {
    await this.props.configureActions.getSensorTypesByReports(groupId);
  };

  onEditScheduledReport = (values) => {
    const _values = Object.assign({}, values);
    _values.typeIds = _values.typeIds.join(',');
    _values.emailList = _values.emailList.split('\n').join(',');
    const { id, departmentId } = this.props.match.params;
    this.props.configureActions
      .editScheduledReport(id, {
        ..._values,
        departmentId,
      })
      .then(() => this.props.history.goBack())
      .catch((err) => console.log(err));
  };
  render() {
    const { scheduledReport, groups } = this.state;
    const _scheduledReport = Object.assign({}, scheduledReport);
    if (Object.keys(_scheduledReport).length) {
      if (groups.length) {
        const group = groups.filter(
          (group) => group.id === _scheduledReport.groupId,
        );
        if (group.length) {
          _scheduledReport.groupName = group[0].name;
        } else {
          _scheduledReport.groupName = '';
        }
      }
      if (_scheduledReport.emailList) {
        _scheduledReport.emailList = _scheduledReport.emailList
          .split(',')
          .join('\n');
      }
      if (
        scheduledReport.typeIds &&
        typeof scheduledReport.typeIds === 'string'
      ) {
        _scheduledReport.typeIds = scheduledReport.typeIds.split(',');
        _scheduledReport.typeIds.map(
          (id, index) => (_scheduledReport.typeIds[index] = parseInt(id)),
        );
      }
    }
    return (
      <EditScheduledReportPage
        {...this.state}
        scheduledReport={_scheduledReport}
        onChangeGroup={this.onChangeGroup}
        onEditScheduledReport={this.onEditScheduledReport}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    configure: state.configure,
    lookup: state.lookup,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    configureActions: bindActionCreators(
      Object.assign({}, configureActions),
      dispatch,
    ),
    lookupActions: bindActionCreators(
      Object.assign({}, lookupActions),
      dispatch,
    ),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditScheduledReport);
